<script>
    export let row = null;
</script>

<ul>
    {#each row.work_sequences as work_sequence}
        <li>{work_sequence.name} - {work_sequence.role_name} - [{work_sequence.duration? work_sequence.duration : "00:00"}]</li>
    {/each}
</ul>